import { useClickstreamAnalytics, ITrackType } from '../clickstream-analytics-context';
import { useCallback } from 'react';
export var useEgClickstream = function () {
    var track = useClickstreamAnalytics().track;
    return useCallback(function (data) {
        track(ITrackType.EVENT, {
            data: data,
            config: { isEgClickstream: true }
        });
    }, [track]);
};
//# sourceMappingURL=use-eg-clickstream.js.map